var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jackpot-physical-help-wrapper" },
    [
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _vm._m(7),
      _vm._m(8),
      _c("div", { staticClass: "h1" }, [_vm._v("Term and Conditions")]),
      _vm._m(9),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-md" }, [
      _c("strong", { staticClass: "text-white text-uppercase" }, [
        _vm._v("Instant Payout:"),
      ]),
      _vm._v(" Received upon collecting a Jackpot ticket "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticStyle: { "list-style-type": "none" } }, [
      _c("li", { staticClass: "flex-center" }, [
        _c("span", { staticClass: "flex-center w-100" }, [
          _c("img", {
            staticClass: "img-small",
            attrs: { src: require("@/assets/images/mini-ticket.webp") },
          }),
          _c(
            "span",
            {
              staticStyle: { color: "#29ffff", "text-transform": "uppercase" },
            },
            [_vm._v("Mini ")]
          ),
        ]),
        _c("span", [
          _vm._v("Up to "),
          _c("strong", [_vm._v("$50 USD")]),
          _vm._v(" can be earned"),
        ]),
      ]),
      _c("li", { staticClass: "flex-center" }, [
        _c("span", { staticClass: "flex-center w-100" }, [
          _c("img", {
            staticClass: "img-small",
            attrs: { src: require("@/assets/images/minor-ticket.webp") },
          }),
          _c(
            "span",
            {
              staticStyle: { color: "#5ce386", "text-transform": "uppercase" },
            },
            [_vm._v("Minor ")]
          ),
        ]),
        _c("span", [
          _vm._v("Up to "),
          _c("strong", [_vm._v("$250 USD")]),
          _vm._v(" can be earned"),
        ]),
      ]),
      _c("li", { staticClass: "flex-center" }, [
        _c("span", { staticClass: "flex-center w-100" }, [
          _c("img", {
            staticClass: "img-small",
            attrs: { src: require("@/assets/images/major-ticket.webp") },
          }),
          _c(
            "span",
            {
              staticStyle: { color: "#ff6f8b", "text-transform": "uppercase" },
            },
            [_vm._v("Major ")]
          ),
        ]),
        _c("span", [
          _vm._v("Up to "),
          _c("strong", [_vm._v("$500 USD")]),
          _vm._v(" can be earned"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-md" }, [
      _c("strong", { staticClass: "text-white text-uppercase" }, [
        _vm._v("Lucky draw:"),
      ]),
      _vm._v(" Prize awarded in every draw"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prize-header major" }, [
      _c("div", [_vm._v("Major Prize:")]),
      _c("div", [_vm._v("1 Winner")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prize-content" }, [
      _c("div", { staticClass: "prize-content-left" }, [
        _c("img", {
          staticClass: "img-small",
          attrs: {
            src: require("@/assets/images/game-help/jackpot/physical/major-gold.webp"),
          },
        }),
        _c("div", [_vm._v("Doji 999.9 gold (18.75g)")]),
      ]),
      _c("div", { staticClass: "prize-content-mid" }, [_vm._v("OR")]),
      _c("div", { staticClass: "prize-content-right" }, [
        _c("img", {
          staticClass: "img-small",
          attrs: {
            src: require("@/assets/images/game-help/jackpot/physical/major-prize.webp"),
          },
        }),
        _c("div", [_vm._v("Iphone 15 Pro max (256gb)")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prize-header minor" }, [
      _c("div", [_vm._v("Minor Prize:")]),
      _c("div", [_vm._v("3 Winners")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prize-content" }, [
      _c("div", { staticClass: "prize-content-left" }, [
        _c("img", {
          staticClass: "img-small",
          attrs: {
            src: require("@/assets/images/game-help/jackpot/physical/minor-gold.webp"),
          },
        }),
        _c("div", [_vm._v("Doji 999.9 gold (3.75g)")]),
      ]),
      _c("div", { staticClass: "prize-content-mid" }, [_vm._v("OR")]),
      _c("div", { staticClass: "prize-content-right" }, [
        _c("img", {
          staticClass: "img-small",
          attrs: {
            src: require("@/assets/images/game-help/jackpot/physical/minor-prize.webp"),
          },
        }),
        _c("div", [_vm._v("PS5 Slim")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prize-header mini" }, [
      _c("div", [_vm._v("Mini Prize:")]),
      _c("div", [_vm._v("8 Winners")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prize-content" }, [
      _c("div", { staticClass: "prize-content-left" }, [
        _c("img", {
          staticClass: "img-small",
          attrs: {
            src: require("@/assets/images/game-help/jackpot/physical/mini-gold.webp"),
          },
        }),
        _c("div", [_vm._v("Doji 999.9 gold (1.875g)")]),
      ]),
      _c("div", { staticClass: "prize-content-mid" }, [_vm._v("OR")]),
      _c("div", { staticClass: "prize-content-right" }, [
        _c("img", {
          staticClass: "img-small",
          attrs: {
            src: require("@/assets/images/game-help/jackpot/physical/mini-prize.webp"),
          },
        }),
        _c("div", [_vm._v("Nintendo Switch (Lite)")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticStyle: { "list-style-type": "none" } }, [
      _c("li", [
        _vm._v(
          " 1. Winners will receive notification via email inbox. Please follow the instructions provided in the email to claim your prize. "
        ),
      ]),
      _c("li", [
        _vm._v("2. Prize not claimed without 45 days will be forfeited."),
      ]),
      _c("li", [_vm._v("3. Winner information will be kept confidential.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }